import { Component, OnDestroy, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RouterFacade } from '@classifieds-sell/state';

@Component({
  selector: 'tm-start-over-button',
  templateUrl: './start-over-button.component.html',
  styleUrls: ['./start-over-button.component.scss']
})
export class StartOverButtonComponent implements OnInit, OnDestroy {
  private _destroyed$: Subject<void> = new Subject<void>();
  public isStartOverModalVisible = false;
  public categoryId: number;
  public subCategory: string;

  constructor(private _routerFacade: RouterFacade) { }

  ngOnInit(): void {
    this._routerFacade.categoryId$.pipe(take(1)).subscribe(categoryId => {
      this.categoryId = categoryId;
    });

    this._routerFacade.subCategory$.pipe(take(1)).subscribe(subCategory => {
      this.subCategory = subCategory;
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
  }

  public onStartOverClose() {
    this.isStartOverModalVisible = false;
  }
}
